import { EventScheduleDataDay, EventScheduleDataEvent } from '../types';
import React from 'react';
import { EventScheduleItem } from './EventScheduleItem';
import { parseISO8601WithTimezone } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';
import { styled } from '@withjoy/joykit';
import { useFormattedDate } from '@shared/hooks/useFormattedDate';

type EventScheduleDayProps = {
  day: EventScheduleDataDay;
  onSelect?: (data: EventScheduleDataEvent) => void;
};

export const DayContainer = styled.div`
  margin-bottom: 2rem;
`;

export const DayTitle = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const EventsList = styled.div`
  border-left: 2px solid #ccc;
  margin-left: 1rem;
  padding-left: 1rem;
`;

export const EventScheduleDay = (props: EventScheduleDayProps) => {
  const { day, onSelect } = props;
  const date = parseISO8601WithTimezone(day.dateISO8601TZ);

  const formattedDate = useFormattedDate(date?.datetime, 'weekday, dd MMMM yyyy');

  if (!date) return null;

  return (
    <DayContainer key={date.datetime.toISOString()}>
      <DayTitle>{formattedDate}</DayTitle>
      <EventsList>
        {day.items.map(event => {
          return (
            <EventScheduleItem
              key={event.id}
              event={event}
              onSelect={onSelect}
            />
          );
        })}
      </EventsList>
    </DayContainer>
  );
};
